import _ from 'lodash';
import dayjs from 'dayjs';
import axios from 'axios';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Highlighter from 'react-highlight-words';
import { decode as base64_decode } from 'base-64';
import TableView from '../../../Widgets/TableView';
import FileBase64 from '../../../Utils/FileUpload';
import { constant } from '../../../Utils/constants';
import React, { useEffect, useRef, useState } from 'react';
import translation from '../../../../../commons/translation';
import HierarchyModal from '../../../Widgets/HierarchyModal';
import localStorage from '../../../../../utils/localStorage';
import InputComponent from '../../../Widgets/InputComponent';
import StyledTable from "../../../../../commons/styles/table";
import FailureCodeDetails from '../../EquipmentRegister/FailureCodeMaster/FailureCodeDetails';
import { Form, message, Select, Modal, DatePicker, Divider, Space, TimePicker, Input, Typography, Button } from 'antd';
import {
  ApartmentOutlined,
  PlusOutlined,
  PaperClipOutlined,
  SearchOutlined
} from '@ant-design/icons';
import {
  getUsersList,
  getDeviceList,
  getSitesList,
  getHierarchyList,
  getFailureCodeList,
  submitMaster,
  getManufacturerList,
  _getDeviceTypesList,
  getMasterList,
  _SaveManufaturerData,
  getEquipmentMasterById
} from '../../../Utils/FormCalls';
import {
  StyledBox,
  StyledBoxLabel
} from '../../../CSS/style';
import {
  API_HIERARCHYMODULE,
  API_MASTERASSetDETAILS,
  API_MASTERITEMS,
  API_PARAMETER
} from '../../../../../commons/api';

const { Option } = Select;
const urlList = {
  insert: API_MASTERASSetDETAILS.INSERT,
  getbyId: API_MASTERASSetDETAILS.GetEquipmentsById,
  itemList: API_MASTERITEMS.LIST
};
const fileData = new FormData();

const EquipmentDetails = (props) => {
  const [sitesList, setSitesList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [visible, setVisible] = useState(false);
  const [ItemdataSource, setItemdataSource] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [Specifications, setSpecifications] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [displayTable] = useState(false);
  const [hierarchyList, setHierarchyList] = useState([]);
  const [failureCodeList, setFailureCodeList] = useState([]);
  const [deviceList, setDeviceList] = useState([]);
  const [ManufacturerList, setManufacturerList] = useState([]);
  const [deviceTypeList, setDeviceTypeList] = useState([]);
  const [viewItemModal, setViewItemModal] = useState(false);
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});
  // const [ViewManufacturerModal, setViewManufacturerModal] = useState(false);
  const [Itemdata, setItemdata] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [viewFCModal, setViewFCModal] = useState(false);
  const searchInput = useRef(null);
  const [, setEditObj] = useState({});
  const [, setDeviceId] = useState(null);
  const [formObject, setFormObject] = useState(
    props.formObject && Object.keys(props.formObject).length > 0 ? props.formObject : {}
  );

  const hRef = useRef();
  const ManufacturerRef = useRef();
  useEffect(() => {
    const fetchData = async () => {
      await _getDataById();
      try {
        let hierarchyList = await getHierarchyList();
        setHierarchyList(hierarchyList);
      } catch (error) {
        message.warning(`${error.message}`);
      }
      try {
        let sitesList = await getSitesList();
        let formObject = hRef.current.getFieldsValue();
        formObject = {
          ...formObject,
          SiteId: localStorage.get('currentSite') ? parseInt(localStorage.get('currentSite')) : ''
        };
        hRef.current.setFieldsValue(formObject);
        setSitesList(sitesList);
        setFormObject(formObject);
      } catch (error) {
        message.warning(`${error.message}`);
      }
      let userList = await getUsersList();
      let failureCodeList = await getFailureCodeList();
      let deviceList = await getDeviceList();
      let ManufacturerList = await getManufacturerList();
      let deviceTypeList = await _getDeviceTypesList();
      let Itemdata = await getMasterList(urlList.itemList);
      setUserList(userList);
      setFailureCodeList(failureCodeList);
      setDeviceList(deviceList);
      setManufacturerList(ManufacturerList);
      setItemdata(Itemdata);
      setDeviceTypeList(deviceTypeList);
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const sites = await getSitesList();
        setSitesList(sites);
        const users = await getUsersList();
        setUserList(users); // Set userList state
      } catch (error) {
        message.warning(`${error.message}`);
      }
    };

    fetchData();
  }, []);

  const _getDataById = async (Equipment) => {
    let formObject = {};
    let path = props.location.pathname.split('/rubus/AMM/EquipmentDetails/');
    let formId = base64_decode(path[1]);
    if (formId !== 'new') {
      formObject = await getEquipmentMasterById(urlList.getbyId, base64_decode(path[1]), 'GET');
      _.cloneDeepWith(formObject, (value) => {
        return value && value !== undefined && value !== null
          ? {
            ...value,
            ...(value['InstallationDate']
              ? (value['InstallationDate'] = dayjs.utc(
                value.InstallationDate,
                'YYYY-MM-DD HH:mm:ss'
              ))
              : null),
            ...(value['UpdatedTime']
              ? (value['UpdatedTime'] = dayjs
                .utc(value.UpdatedTime, 'YYYY-MM-DD HH:mm:ss')
                .local())
              : null),
            ...(value['CreatedTime']
              ? (value['CreatedTime'] = dayjs
                .utc(value.CreatedTime, 'YYYY-MM-DD HH:mm:ss')
                .local())
              : null),
            ...(value['TotalDownTime']
              ? (value['TotalDownTime'] = dayjs.utc(
                value.TotalDownTime,
                'YYYY-MM-DD HH:mm'
              )).local()
              : null)
          }
          : _.noop();
      });
      formObject = {
        ...formObject,
        Specifications: formObject && formObject.Specifications ? formObject.Specifications : [],
        SelectedDataTable: formObject && formObject.FailureCodes ? formObject.FailureCodes : [],
        ItemdataSource: formObject && formObject.Items ? formObject.Items : [],
        Location: formObject.Location,
        FailureCodes:
          formObject &&
          formObject.FailureCodes &&
          Array.isArray(formObject.FailureCodes) &&
          formObject.FailureCodes.map((item) => {
            return item;
          })
      };
    } else if (Equipment) {
      formObject = await getEquipmentMasterById(urlList.getbyId, Equipment, 'GET');
      _.cloneDeepWith(formObject, (value) => {
        return value && value !== undefined && value !== null
          ? {
            ...value,
            ...(value['InstallationDate']
              ? (value['InstallationDate'] = dayjs.utc(
                value.InstallationDate,
                'YYYY-MM-DD HH:mm:ss'
              ))
              : null),
            ...(value['UpdatedTime']
              ? (value['UpdatedTime'] = dayjs
                .utc(value.UpdatedTime, 'YYYY-MM-DD HH:mm:ss')
                .local())
              : null),
            ...(value['CreatedTime']
              ? (value['CreatedTime'] = dayjs
                .utc(value.CreatedTime, 'YYYY-MM-DD HH:mm:ss')
                .local())
              : null),
            ...(value['TotalDownTime']
              ? (value['TotalDownTime'] = dayjs.utc(
                value.TotalDownTime,
                'YYYY-MM-DD HH:mm'
              )).local()
              : null)
          }
          : _.noop();
      });
      formObject = {
        ...formObject,
        SelectedDataTable: formObject && formObject.FailureCodes ? formObject.FailureCodes : [],
        ItemdataSource: formObject && formObject.Items ? formObject.Items : [],
        Specifications: formObject && formObject.Specifications ? formObject.Specifications : [],
        FailureCodes:
          formObject &&
          formObject.FailureCodes &&
          Array.isArray(formObject.FailureCodes) &&
          formObject.FailureCodes.map((item) => {
            return item;
          })
      };
    }

    if (hRef.current) {
      hRef.current.setFieldsValue(formObject);
    }
    let selectedRowKeys =
      formObject.Items && Array.isArray(formObject.Items)
        ? formObject.Items.map((item1) => {
          return item1.Id;
        })
        : [];
    setFormObject(formObject);
    setSelectedRowKeys(selectedRowKeys);
    setSpecifications(formObject.Specifications);
    setItemdataSource(formObject.Items);
    setSelectedRows(formObject.Items);
  };

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
    if (props.formObject !== formObject) {
      setFormObject(props.formObject || {});
    }
  }, [props.translationCache, props.formObject]);

  const fileupload = async (values, key, fileDataObject) => {
    let currentFormObject = hRef.current.getFieldsValue();

    if (currentFormObject[key]) {
      currentFormObject[key].push(...values);
    } else {
      currentFormObject[key] = values;
    }

    currentFormObject[key] =
      currentFormObject[key] &&
      Array.isArray(currentFormObject[key]) &&
      currentFormObject[key].reduce((acc, current) => {
        const x = acc.find((item) => item.Name === current.Name);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);

    currentFormObject = {
      ...currentFormObject,
      Specifications: currentFormObject.Specifications,
      [key]: currentFormObject[key],
    };

    fileData.append('files', fileDataObject);

    if (hRef.current) hRef.current.setFieldsValue(currentFormObject);
    setFormObject(currentFormObject);
  };

  const disabledDate = (current) => {
    return current && current > dayjs().endOf('day');
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(props.translationCache, constant.search)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}

          style={{ width: 90, marginRight: 8 }}
        >
          {translation(props.translationCache, constant.search)}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}

          style={{ width: 90 }}
        >
          {translation(props.translationCache, constant.Reset)}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: () => {
      if (viewFCModal) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const onFormsubmit = async (values) => {
    let userId =
      props.userProfile && props.userProfile.Id
        ? props.userProfile.Id
        : '';
    let specValidate =
      formObject && formObject.Specifications && Array.isArray(formObject.Specifications)
        ? formObject.Specifications.filter((spec) => {
          return spec.editable === true;
        })
        : [];

    if (specValidate && Array.isArray(specValidate) && specValidate.length === 0) {
      let Specifications =
        formObject &&
        formObject.Specifications &&
        Array.isArray(formObject.Specifications) &&
        formObject.Specifications.map((spec) => {
          delete spec.editable;
          return {
            ...spec
          };
        });

      let payload = {
        ...formObject,
        ...values,
        Items:
          ItemdataSource && ItemdataSource !== undefined && Array.isArray(ItemdataSource)
            ? ItemdataSource
            : [],
        Location: values.Location,
        Specifications,
        TimeSeries: true,
        ...(formObject && !formObject.Id ? { CreatedBy: userId } : {}),
        ...(formObject && formObject.Id ? { UpdatedBy: userId } : {})
      };

      let statusResponse = await submitMaster(urlList.insert, payload, fileData);
      if (statusResponse && statusResponse.message) {
        _getDataById(statusResponse.deviceId);
        message.success(statusResponse.message);
        if (statusResponse && !statusResponse.Error) {
          props.navigate('/rubus/AMM/EquipmentList');
        }
      } else if (statusResponse && statusResponse.Error) {
        message.error(statusResponse.Error);
      }
    } else {
      message.error('Please save specifications before submitting record');
    }
  };


  const hierarchyDropdownChange = (value) => {
    let currentFormObject = hRef.current.getFieldsValue();
    currentFormObject = {
      ...currentFormObject,
      Location: value.Code,
      LocationDescription: value.Name
    };

    hRef.current.setFieldsValue(currentFormObject);
    setModalVisible(false);
    setFormObject(currentFormObject);
  };

  const AssetHierarchyDropdownChange = (value) => {
    let currentFormObject = hRef.current.getFieldsValue();
    currentFormObject = {
      ...currentFormObject,
      Location: value.Location,
      LocationDescription: value.Name,
      AssetDisplayCode: value.Location
    };
    hRef.current.setFieldsValue(currentFormObject);
    setVisible(false);
    setEditObj(currentFormObject);
    setFormObject(currentFormObject);
  };

  const parentNode = (parent) => {
    let currentFormObject = hRef.current.getFieldsValue();
    currentFormObject = {
      ...currentFormObject,
      Location: parent.Code,
      LocationDescription: parent.Name
    };
    hRef.current.setFieldsValue(currentFormObject);
    setModalVisible(false);
    setFormObject(currentFormObject);
  };

  const parentNode1 = (parent) => {
    let currentFormObject = hRef.current.getFieldsValue();
    currentFormObject = {
      ...currentFormObject,
      Location: parent.Code,
      LocationDescription: parent.Name
    };

    hRef.current.setFieldsValue(currentFormObject);
    setVisible(false);
    setFormObject(currentFormObject);
  };
  const onDrawerCancel = (e) => {
    if (e.target.tagName === 'DIV') {
      e.preventDefault();
      message.error('Please Select Location');
    } else {
      setVisible(false);
    }
  };

  const onModalCancel = (e) => {
    let formObject = hRef.current.getFieldsValue();
    if (formObject.Location === undefined && e.target.tagName === 'DIV') {
      e.preventDefault();
      message.error('Please Select Location');
    } else {
      setModalVisible(false);
    }
  };

  const onModalOk1 = () => {
    // message.error('Please Select Location');
    setVisible(false);

  };
  const onModalOk = () => {
    // message.error('Please Select Location');
    setModalVisible(false);

  };
  const getHierarchyLevels = () => {
    let payload = {
      HierarchyCode:
        hierarchyList &&
          Array.isArray(hierarchyList) &&
          hierarchyList[0] &&
          hierarchyList[0].HierarchyCode
          ? hierarchyList[0].HierarchyCode
          : null,
      Type: 'Asset'
    };
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let headers = {
      method: 'GET',
      url: `${API_HIERARCHYMODULE.GetHierarchyLevels}?SiteId=${siteId}&HierarchyCode=${payload.HierarchyCode}&Type=${payload.Type}&&HierarchyType=AMM`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(headers)
      .then(({ data }) => {
        if (Array.isArray(data)) {
          setTreeData(data);
          setVisible(true);
          setFormObject(hRef.current.getFieldsValue());
        }
      })
      .catch(function () { });
  };

  const handleChange = async () => {
    let formObject = hRef.current.getFieldsValue();
    formObject = {
      ...formObject
    };
    hRef.current.setFieldsValue(formObject);
    setFormObject(formObject);
  };

  const EquipmentCategoryChange = (data, key) => {
    if (key === 'DeviceType') {
      let formObject = hRef.current.getFieldsValue();
      let selectedDeviceType = deviceTypeList.filter((test) => test.Code === data);
      let selectedEquipment = selectedDeviceType[0];
      formObject = {
        ...formObject,
        EquipmentCategory: selectedEquipment.Code,
        EquipmentCategoryDescription: selectedEquipment.Description
      };
      setFormObject(formObject);
      hRef.current.setFieldsValue(formObject);
    }
  };

  const onFCModalSubmit = async () => {
    let failureCodeList = await getFailureCodeList();
    setFailureCodeList(failureCodeList);
    setViewFCModal(false);
  };

  const onChange = () => {
    let formObject = hRef.current.getFieldsValue();
    formObject = {
      ...formObject
    };
    hRef.current.setFieldsValue(formObject);
    setFormObject(formObject);
  };

  const onManufacturerClick = (data) => {
    let formObject = hRef.current.getFieldsValue();
    let testdata = ManufacturerList.filter((test) => test.Id === data);
    formObject = {
      ...formObject,
      Manufacturer: data,
      ManufacturerDescription: testdata[0].Description
    };
    hRef.current.setFieldsValue(formObject);
    setFormObject(formObject);
  };

  const oncloseManufaturer = (e) => {
    if (e.target.tagName === 'DIV') {
      e.preventDefault();
      message.error('Please verify fields');
    } else {
      setViewFCModal(false);
    }
  };

  const addNewManufaturer = () => {
    setViewFCModal(true);
    if (ManufacturerRef.current) {
      ManufacturerRef.current.resetFields();
    }
  };

  const onModalManufacturerFormsubmit = (e) => {

    e.preventDefault();
    ManufacturerRef.current
      .validateFields()
      .then(async (values) => {
        let ManufaturerReponse = await _SaveManufaturerData(values);
        if (ManufaturerReponse) {
          message.success(ManufaturerReponse.message);
          let ManufacturerList = await getManufacturerList();
          let testdata = ManufacturerList.filter(
            (test) =>
              test.Description === values.Description && test.Manufacturer === values.Manufacturer
          );
          let formObject = hRef.current.getFieldsValue();
          formObject = {
            ...formObject,
            Manufacturer: testdata[0].Id,
            ManufacturerDescription: testdata[0].Description
          };
          hRef.current.setFieldsValue(formObject);
          setViewFCModal(false);
          setManufacturerList(ManufacturerList);
          setFormObject(formObject);
          if (ManufacturerRef.current) {
            ManufacturerRef.current.resetFields();
          }
        }
      })
      .catch(() => { });
  };

  const addItem = () => {
    setViewItemModal(true);
  };

  const onItemModalOk = () => {
    setViewItemModal(false);
    setItemdataSource([...selectedRows]);
  };

  const onItemModalCancel = (e) => {
    if (e.target.tagName === 'DIV') {
      e.preventDefault();
      message.error('Please verify fields');
    } else {
      setViewItemModal(false);
      setSelectedRowKeys(
        ItemdataSource && Array.isArray(ItemdataSource)
          ? ItemdataSource.map((item) => {
            return item.Id;
          })
          : []
      );
    }
  };

  const onSelectedRowKeysChange = (selectedRowKeys, selectedRows) => {
    setSelectedRowKeys(selectedRowKeys);
    setSelectedRows(selectedRows);
  };

  const saveTableViewData = (Specifications) => {
    let formObject = hRef.current.getFieldsValue();
    formObject = {
      ...formObject,
      Specifications
    };
    setFormObject(formObject);
    setSpecifications(Specifications);
  };

  const onFCModalCancel = () => {
    setViewFCModal(false);
  };

  const validateMessages = {
    required: '${label} is required!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!',
    },
    number: {
      range: '${label} must be between ${min} and ${max}',
    },
    pattern: {
      mismatch: '${label} does not match pattern',
    },
  };

  // Table columns
  const modalTableColumns = [
    {
      title: translation(translationCache, constant.failureClass),
      key: 'FailureCode',
      dataIndex: 'FailureCode',
    },
    {
      title: translation(translationCache, constant.failureDescription),
      key: 'Description',
      dataIndex: 'Description',
    },
  ];

  const EquipmentColumns = [
    {
      title: translation(translationCache, constant.name),
      key: 'Name',
      dataIndex: 'Name',
      widget: 'input',
      required: true,
    },
    {
      title: translation(translationCache, constant.value),
      key: 'Value',
      dataIndex: 'Value',
      widget: 'inputNumber',
      required: true,
    },
    {
      title: translation(translationCache, constant.unitOfMeasure),
      key: 'UOM',
      dataIndex: 'UOM',
      widget: 'select',
      required: true,
      table: {
        url: `${API_PARAMETER.GetUOM}`,
        method: 'GET',
      },
    },
  ];

  const selectedItemColumns = [
    {
      title: translation(translationCache, constant.item),
      key: 'Item',
      dataIndex: 'Item',
      widget: 'input',
      ...getColumnSearchProps('Item'),
    },
    {
      title: translation(translationCache, constant.itemType),
      key: 'ItemType',
      dataIndex: 'ItemType',
      widget: 'input',
      ...getColumnSearchProps('ItemType'),
    },
    {
      title: translation(translationCache, constant.itemDescription),
      key: 'Description',
      dataIndex: 'Description',
      widget: 'input',
      ...getColumnSearchProps('Description'),
    },
  ];

  const itemColumns = [
    {
      title: translation(translationCache, constant.item),
      key: 'Item',
      dataIndex: 'Item',
      widget: 'input',
      ...getColumnSearchProps('Item'),
    },
    {
      title: translation(translationCache, constant.itemType),
      key: 'ItemType',
      dataIndex: 'ItemType',
      widget: 'input',
      ...getColumnSearchProps('ItemType'),
    },
    {
      title: translation(translationCache, constant.itemDescription),
      key: 'Description',
      dataIndex: 'Description',
      widget: 'input',
      ...getColumnSearchProps('Description'),
    },
  ];

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectedRowKeysChange
  };
  const themeBackground = props && props.themeValue && props.themeValue.token && props.themeValue.token.colorBgBase;
  return (
    <>

      <Form
        name="Equipment Master"
        ref={hRef}
        onFinish={onFormsubmit}
        onKeyDown={(e) => {
          e.key === 'Enter' && e.preventDefault();
        }}
        initialValues={formObject || {}}
        layout="horizontal"
        labelCol={{ flex: '130px' }}
        labelAlign="right"
        labelWrap
        validateMessages={validateMessages}
      >
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <Button
            style={{ marginRight: '5px' }}

            htmlType="submit"
          >
            <Link
              to={{
                pathname: `/rubus/AMM/EquipmentOverviewDetails/${formObject?.Equipment}`
              }}
            >
              {translation(translationCache, constant.overview)}
            </Link>
          </Button>
          <Button
            style={{ marginRight: '5px' }}

            htmlType="submit"
          >
            <Link to={{ pathname: `/rubus/AMM/CMDetails/bmV3` }}>
              {translation(translationCache, constant.CM)}
            </Link>
          </Button>
          <Button
            style={{ marginRight: '5px' }}
            htmlType="submit"
          >
            <Link to={{ pathname: `/rubus/AMM/EquipmentTagDetails/bmV3` }}>
              {translation(translationCache, constant.EquipmentTags)}
            </Link>
          </Button>
          <Button htmlType="submit">
            {translation(translationCache, constant.submit)}
          </Button>
        </div>
        <StyledBox themeBackground={themeBackground} style={{ display: 'flex', flexWrap: 'wrap' }}>
          <Form.Item name={'Id'}></Form.Item>
          <Form.Item name={'Location'}></Form.Item>
          <StyledBoxLabel>
            <Typography.Title level={5}>{translation(translationCache, constant.EquipmentDetails)}</Typography.Title>
          </StyledBoxLabel>
          <Form.Item
            style={{
              width: '100%',
              flex: '50%',
              marginTop: '40px'
            }}
            className="label"
            label={translation(translationCache, constant.equipment)}
            name="Equipment"
            rules={[{ required: true }]}
          >
            <InputComponent
              style={{
                width: '70%',
                cursor: formObject?.Id ? 'not-allowed' : null,
                opacity: formObject?.Id ? '0.8' : null
              }}
              placeholder={translation(props.translationCache, constant.inputEquipment)}
              disabled={
                formObject?.EquipmentFlag === true
              }
            />
          </Form.Item>
          <Form.Item name="EquipmentFlag"></Form.Item>
          <Form.Item
            style={{
              width: '100%',
              flex: '50%',
              marginTop: '40px'
            }}
            label={translation(translationCache, constant.equipmentDescription)}
            name="EquipmentDescription"
            rules={[{ required: true }]}
          >
            <InputComponent
              style={{ width: '70%' }}
              placeholder={translation(
                props.translationCache,
                constant.Inputequipmentdescription
              )}
              disabled={
                formObject?.EquipmentFlag === true
              }
            />
          </Form.Item>
          <Form.Item
            style={{
              width: '100%',
              flex: '50%'
            }}
            label={translation(translationCache, constant.DisplayCode)}
            name="DisplayCode"
            rules={[{ required: true }]}
          >
            <InputComponent
              style={{ width: '70%' }}
              placeholder={translation(
                props.translationCache,
                constant.InputDisplayCode
              )}
            />
          </Form.Item>
          <Form.Item
            style={{
              width: '100%',
              flex: '50%'
            }}
            label={translation(translationCache, constant.equipmentCategory)}
            name="EquipmentCategory"
            rules={[{ required: true }]}
          >
            <Select
              style={{ width: '70%' }}
              placeholder={translation(
                props.translationCache,
                constant.SelectEquipmentCategory
              )}
              onChange={(e) => EquipmentCategoryChange(e, 'DeviceType')}
              disabled={
                formObject?.EquipmentFlag === true
              }
            >
              {deviceTypeList
                ? deviceTypeList.map((deviceType, index) => (
                  <Option key={index} value={deviceType.Code}>
                    {translation(translationCache, deviceType.Name)}
                  </Option>
                ))
                : null}
            </Select>
          </Form.Item>
          <Form.Item
            style={{
              width: '100%',
              flex: '50%'
            }}
            label={translation(translationCache, constant.equipmentCategoryDescription)}
            name="EquipmentCategoryDescription"
            rules={[{ required: true }]}
          >
            <InputComponent
              style={{ width: '70%' }}
              placeholder={translation(
                props.translationCache,
                constant.AutopopulatebasedonEquipmentCategory
              )}
              disabled={true}
            />
          </Form.Item>

          <Form.Item
            style={{ width: '100%', flex: '50%' }}
            label={translation(translationCache, constant.location)}
            name="AssetDisplayCode"
            rules={[{ required: true }]}
          >
            <Select
              style={{ width: '70%' }}
              placeholder={translation(props.translationCache, constant.SelectLocation)}
              disabled={true}
              suffixIcon={
                <ApartmentOutlined
                  style={{
                    color: formObject?.Id ? 'rgba(0,0,0,0.66)' : '#1a3b5c',
                    cursor: formObject?.EquipmentFlag ? 'not-allowed' : null,
                    opacity: formObject?.EquipmentFlag ? '0.3' : null
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    if (formObject && !formObject.Id) {
                      getHierarchyLevels('visible');
                    }
                  }}
                />
              }
            >
              {deviceList &&
                Array.isArray(deviceList) &&
                deviceList.map((device, index) => {
                  return (
                    <Option key={index} value={device.DeviceCode}>
                      {' '}
                      {device.DeviceCode}{' '}
                    </Option>
                  );
                })}
            </Select>
          </Form.Item>
          <Form.Item
            style={{
              width: '100%',
              flex: '50%'
            }}
            label={translation(translationCache, constant.locationDescription)}
            name="LocationDescription"
            rules={[{ required: true }]}
          >
            <InputComponent
              style={{ width: '70%' }}
              placeholder={translation(
                props.translationCache,
                constant.AutopopulatebasedonLocation
              )}
              disabled={true}
            />
          </Form.Item>
          <Form.Item
            style={{ width: '100%', flex: '50%' }}
            label={<div>{translation(translationCache, constant.failureClass)}</div>}
            name="FailureCodes"
          >
            <Select
              value={formObject?.FailureCodes}
              mode="multiple"
              showArrow={true}
              placeholder={translation(
                props.translationCache,
                constant.SelectFailureCode
              )}
              style={{ width: '70%' }}
              dropdownRender={(menu) => (
                <>
                  {menu}
                  <Divider
                    style={{
                      margin: '8px 0'
                    }}
                  />
                  <Space
                    style={{
                      padding: '0 8px 4px'
                    }}
                  >
                    <Button
                      onClick={() => {
                        setViewFCModal(true);
                      }}
                    >
                      {translation(translationCache, constant.addFailureClass)}
                    </Button>
                  </Space>
                </>
              )}
            >
              {failureCodeList &&
                Array.isArray(failureCodeList) &&
                failureCodeList.map((code, index) => {
                  return (
                    <Option key={index} value={code.Id}>
                      {' '}
                      {code.FailureCode}{' '}
                    </Option>
                  );
                })}
            </Select>
          </Form.Item>
          <Form.Item
            style={{
              width: '100%',
              flex: '50%'
            }}
            label={translation(translationCache, constant.site)}
            name="SiteId"
            rules={[{ required: true }]}
          >
            <Select
              style={{ width: '70%' }}
              placeholder={translation(props.translationCache, constant.SelectSite)}
              disabled={
                formObject?.EquipmentFlag === true
              }
              onChange={(e) => handleChange(e, 'SiteId')}
            >
              {sitesList &&
                Array.isArray(sitesList) &&
                sitesList.map((site, index) => {
                  return (
                    <Option key={index} value={site.Id}>
                      {' '}
                      {site.Name}{' '}
                    </Option>
                  );
                })}
            </Select>
          </Form.Item>
          <Form.Item
            style={{
              width: '100%',
              flex: '50%'
            }}
            label={translation(translationCache, constant.TotalDowntime)}
            name="TotalDownTime"
          >
            <TimePicker
              style={{ width: '70%' }}
              placeholder={translation(
                props.translationCache,
                constant.InputTotalDowntime
              )}
              format={'HH:mm'}
              defaultOpenValue={dayjs('00:00', 'HH:mm')}
              onChange={(value) => handleChange(value, 'TotalDownTime')}
            />
          </Form.Item>
          <Form.Item style={{ width: '100%', flex: '50%' }}>
            <InputComponent style={{ display: 'none' }} />
          </Form.Item>
        </StyledBox>
        <StyledBox themeBackground={themeBackground} style={{ display: 'flex', flexWrap: 'wrap' }}>
          <StyledBoxLabel>
            <Typography.Title level={5}>
              {translation(translationCache, constant.EquipmentCatalogue)}</Typography.Title>
          </StyledBoxLabel>

          <Form.Item
            style={{ width: '100%', flex: '50%', marginTop: '40px' }}
            label={translation(translationCache, constant.specificationNumber)}
            name="SpecNumber"
            rules={[
              {
                // pattern: new RegExp(/^[A-Za-z0-9 ]*$/)
              }
            ]}
          >
            <InputComponent
              style={{ width: '70%' }}
              placeholder={translation(props.translationCache, constant.InputSpecNo)}
            />
          </Form.Item>
          <Form.Item
            style={{ width: '100%', flex: '50%', marginTop: '40px' }}
            label={translation(translationCache, constant.usageCondition)}
            name="UsageCondition"
            rules={[
              {
                pattern: new RegExp(
                  /^[一-龯ぁ-んァ-ンぁ-んァ-ン\wぁ-んァ-ンｧ-ﾝﾞﾟぁ-ゞ0-9A-Za-zァ-ヶｦ-ﾟ-_&一 ]*$/
                )
              }
            ]}
          >
            <InputComponent
              style={{ width: '70%' }}
              placeholder={translation(
                props.translationCache,
                constant.InputUsageCondition
              )}
            />
          </Form.Item>
          <Form.Item
            style={{ width: '100%', flex: '50%' }}
            label={translation(translationCache, constant.serialNo)}
            name="SerialNumber"
            rules={[
              {
                // pattern: new RegExp(/^[A-Za-z0-9 ]*$/)
              }
            ]}
          >
            <InputComponent
              style={{ width: '70%' }}
              placeholder={translation(props.translationCache, constant.InputSerialNo)}
            />
          </Form.Item>
          <Form.Item
            style={{ width: '100%', flex: '50%' }}
            label={translation(translationCache, constant.installationDate)}
            name="InstallationDate"
          >
            <DatePicker
              inputReadOnly={true}
              placeholder={translation(translationCache, constant.selectinstallationDate)}
              style={{ width: '70%' }}
              value={dayjs().format('YYYY-MM-DD HH:mm:ss')}
              disabledDate={disabledDate}
            />
          </Form.Item>
          <Form.Item
            style={{ width: '100%', flex: '50%' }}
            label={translation(translationCache, constant.manufacturer)}
            name="Manufacturer"
          >
            <Select
              style={{ width: '70%' }}
              placeholder={translation(
                props.translationCache,
                constant.SelectManufacturer
              )}
              onChange={(e) => onManufacturerClick(e)}
              dropdownRender={(menu) => (
                <>
                  {menu}
                  <Divider
                    style={{
                      margin: '8px 0'
                    }}
                  />
                  <Space
                    style={{
                      padding: '0 8px 4px'
                    }}
                  >
                    <Button
                      type="dashed"
                      icon={<PlusOutlined />}
                      onClick={() => addNewManufaturer()}
                    >
                      {translation(translationCache, 'Add Manufacturer')}
                    </Button>
                  </Space>
                </>
              )}
            >
              {ManufacturerList &&
                Array.isArray(ManufacturerList) &&
                ManufacturerList.map((code, index) => {
                  return (
                    <Option key={index} value={code.Id}>
                      {code.Manufacturer}
                    </Option>
                  );
                })}
            </Select>
          </Form.Item>
          <Form.Item
            style={{ width: '100%', flex: '50%' }}
            label={translation(translationCache, constant.manufacturerDescription)}
            name={'ManufacturerDescription'}
          >
            <InputComponent
              style={{ width: '70%', color: 'black' }}
              placeholder={translation(
                constant.AutoPopulatebasedonManufacturer
              )}
              disabled
            />
          </Form.Item>
          <Form.Item
            style={{ width: '100%', flex: '50%' }}
            label={translation(translationCache, constant.createdBy)}
            name="CreatedBy"
          >
            <Select
              style={{ width: '70%' }}
              value={formObject?.CreatedBy}
              placeholder={translation(props.translationCache, constant.CreatedBy)}
              disabled={true}
            >
              {userList &&
                Array.isArray(userList) &&
                userList.map((user, index) => {
                  return (
                    <Option key={index} value={user.Id}>
                      {' '}
                      {user.FirstName}{' '}
                    </Option>
                  );
                })}
            </Select>
          </Form.Item>
          <Form.Item
            style={{ width: '100%', flex: '50%' }}
            label={translation(translationCache, constant.createdDate)}
            name="CreatedTime"
          >
            <DatePicker
              placeholder={translation(translationCache, constant.createdDate)}
              format="YYYY-MM-DD HH:mm:ss"
              inputReadOnly={true}
              style={{ width: '70%' }}
              disabled={true}
            />
          </Form.Item>
          <Form.Item
            style={{ width: '100%', flex: '50%' }}
            name="Attachments"
            label={
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span >
                  {translation(translationCache, constant.attachments)}
                  <PaperClipOutlined className="plusCircleOutlined" />
                </span>
              </div>
            }
          >
            <FileBase64
              downloadClassName={'formdownloadInput'}
              Attachments={formObject?.Attachments}
              fileUpload={fileupload}
            />
          </Form.Item>
          {formObject?.Id ? (
            <>
              <Form.Item
                style={{ width: '100%', flex: '50%' }}
                label={translation(translationCache, constant.modifiedBy)}
                name="UpdatedBy"
              >
                <Select
                  style={{ width: '70%' }}
                  value={formObject?.UpdatedBy}
                  placeholder={translation(props.translationCache, constant.UpdatedBy)}
                  disabled={true}
                >
                  {userList &&
                    Array.isArray(userList) &&
                    userList.map((user, index) => {
                      return (
                        <Option key={index} value={user.Id}>
                          {' '}
                          {user.FirstName}{' '}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
              <Form.Item
                style={{ width: '100%', flex: '50%' }}
                label={translation(translationCache, constant.modifiedDate)}
                name="UpdatedTime"
              >
                <DatePicker
                  placeholder={translation(translationCache, constant.selectDate)}
                  format="YYYY-MM-DD HH:mm:ss"
                  inputReadOnly={true}
                  style={{ width: '70%' }}
                  defaultValue={dayjs()}
                  disabled={true}
                />
              </Form.Item>
            </>
          ) : null}
          <Form.Item style={{ width: '100%', flex: '50%' }}>
            <InputComponent style={{ display: 'none' }} />
          </Form.Item>
        </StyledBox>

        <Modal
          title={translation(translationCache, constant.addManufacturer)}
          open={false}
          okText={'Submit'}
          onOk={(e) => onModalManufacturerFormsubmit(e)}
          onCancel={oncloseManufaturer}
        >
          <Form
            layout="vertical"
            ref={ManufacturerRef}
            name="user_form"
            onFinish={(e) => onModalManufacturerFormsubmit(e)}
          >
            <Form.Item
              style={{ width: '100%', flex: '50%' }}
              label={translation(translationCache, constant.Manufacturer)}
              name={'Manufacturer'}
              placeholder={translation(
                props.translationCache,
                constant.PleaseenterManufacturer
              )}
              rules={[{ required: true }]}
            >
              <InputComponent
                placeholder={translation(
                  props.translationCache,
                  constant.PleaseenterManufacturer
                )}
                onChange={(e) => onChange(e)}
              />
            </Form.Item>
            <Form.Item
              style={{ width: '100%', flex: '50%' }}
              label={translation(translationCache, constant.Description)}
              name={'Description'}
              placeholder={translation(
                props.translationCache,
                constant.PleaseenterDescription
              )}
              rules={[
                { required: true },
              ]}
            >
              < InputComponent
                placeholder={translation(
                  constant.PleaseenterDescription
                )}
              />
            </Form.Item>
          </Form>
        </Modal>
        <Modal
          open={modalVisible}
          width={800}
          closable
          title={translation(translationCache, constant.hierarchy)}
          onOk={onModalOk}
          onCancel={onModalCancel}
        >
          <HierarchyModal
            value={setDeviceId}
            treeData={treeData}
            translationCache={props.translationCache}
            Key="Location"
            handleDropdownChange={hierarchyDropdownChange}
            handleParentNode={parentNode}
          />
        </Modal>
        <Modal
          open={visible}
          width={800}
          closable
          title={translation(translationCache, constant.hierarchy)}
          onOk={onModalOk1}
          onCancel={onDrawerCancel}
        >
          <HierarchyModal
            value={setDeviceId}
            treeData={treeData}
            translationCache={props.translationCache}
            Key="Asset"
            handleDropdownChange={AssetHierarchyDropdownChange}
            handleParentNode={parentNode1}
            deviceList={deviceList}
          />
        </Modal>

        {displayTable === true ? (
          <TableView form={{ columns: modalTableColumns }} />
        ) : (
          ''
        )}

        <Form.Item name="FailureCodes" style={{ width: '100%', flex: '50%' }}></Form.Item>

        <StyledBox>
          <StyledBoxLabel>
            <Typography.Title level={5}>
              {translation(translationCache, constant.item)}</Typography.Title>
          </StyledBoxLabel>
          <Modal
            open={viewItemModal}
            width={800}
            closable
            title={translation(translationCache, constant.addItem)}
            onOk={(e) => {
              onItemModalOk(e);
            }}
            onCancel={onItemModalCancel}
          >
            <StyledTable size="small"
              rowSelection={rowSelection}
              columns={itemColumns}
              dataSource={Itemdata}
            />
          </Modal>
          <div style={{ padding: '20px 10px' }}>
            <StyledTable size="small"
              columns={selectedItemColumns}
              dataSource={ItemdataSource}
            />
            <Button
              style={{ marginTop: '5px' }}
              type="primary"
              onClick={() => {
                addItem();
              }}
            >
              {translation(translationCache, constant.addItem)}
            </Button>
          </div>
        </StyledBox>

        <StyledBox>
          <StyledBoxLabel>
            <Typography.Title level={4}>
              {translation(translationCache, constant.specifications)}
            </Typography.Title>
          </StyledBoxLabel>
          <div style={{ padding: '20px 10px' }}>
            <TableView
              form={{ columns: EquipmentColumns, datasource: Specifications }}
              recordType={'Item Specifications'}
              saveTableViewData={(e) => saveTableViewData(e, 'Specifications')}
              showAddButton={true}
            />
          </div>
        </StyledBox>

        <Modal
          open={viewFCModal}
          width={800}
          closable
          footer={null}
          title={translation(props.translationCache, constant.AddFailureClass)}
          // onOk={onFCModalOk}
          onCancel={onFCModalCancel}
        >
          <FailureCodeDetails
            EWOModal={true}
            viewFCModal={viewFCModal}
            onFCModalSubmit={onFCModalSubmit}
            onFCModalCancel={onFCModalCancel}
            formObject={{}}
          />
        </Modal>
      </Form>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    themeValue: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    userProfile: state.LayoutReducer.UserDetails,
  };
};

export default connect(mapStateToProps)(EquipmentDetails);